import apiClient from "./axios";

/**
 * Payroll API Service
 * Clean production version (no timeout)
 */
const payrollApi = {

  /**
   * Download payroll deductions Excel
   * @param {String|null} month - optional format e.g. 2026-02
   * @param {Object} config - optional axios config (progress, cancel token, etc.)
   */
  downloadPayrollExcel: (month = null, config = {}) => {
    return apiClient.get("/test/send-payroll", {
      params: month ? { month } : {},
      responseType: "blob", // required for file download
      ...config
    });
  },

  /**
   * Trigger payroll generation + email
   */
  triggerPayrollEmail: () => {
    return apiClient.get("/test/send-payroll-email");
  },

  // Save multiple receipts in batch (POST /api/transactions/receipt/batch)
  importBatch(payloads) {
    return apiClient.post("/test/import-batch", payloads);
  },

};

export default payrollApi;
